import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Apps from './pages/Apps';
import BartMenu from './pages/BartMenu';
import DishList from './pages/DishList';
import DishListInvite from './pages/DishListInvite';
import PawKit from './pages/PawKit';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import DrinkResponsibly from './pages/DrinkResponsibly';
import FoodSupport from './pages/FoodSupport';
import './App.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/apps/bartmenu" element={<BartMenu />} />
            <Route path="/apps/dishlist" element={<DishList />} />
            <Route path="/invites-dishlist/:inviteId" element={<DishListInvite />} />
            <Route path="/apps/pawkit" element={<PawKit />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/drink-responsibly" element={<DrinkResponsibly />} />
            <Route path="/food-support" element={<FoodSupport />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
